import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuthStore } from "../../store/auth.store";
import { EXAM_OPERATIONS_ROLE_MESSAGE, canUseExamOperations } from "./exam-operations.access";

/**
 * Garde de rôle de « Priorités de réservation » (D18) : avant le contrôle RdvPermis et avant tout appel
 * à /v1/exam-operations, un rôle non admis par le serveur reçoit un message clair.
 */
export function ExamOperationsRoleAccess({ children }: { children: ReactNode }) {
  const role = useAuthStore((s) => s.user?.role);
  if (canUseExamOperations(role)) return <>{children}</>;
  return (
    <section className="billing-notice">
      <h2>Priorités de réservation</h2>
      <p role="alert">{EXAM_OPERATIONS_ROLE_MESSAGE}</p>
      <div className="billing-navigation__tabs">
        <Link className="btn btn--ghost" to="/today">
          Retour à l’accueil
        </Link>
      </div>
    </section>
  );
}
